import LogoutForm from "@arelia-components/api-authorization/LogoutForm";
import Header from "@arelia-components/layout/Header";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import { Account } from "@arelia-types/index";
import { Box, Button } from "@mui/material";
import { mergeWith } from "lodash";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PATHS } from "src/routes";
import { useSaveAccount } from "../../../api/account";
import AppContext from "../../../AppContext";
import ProfilePresenter from "./ProfilePresenter";

export default function ProfileContainer() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const navOptions = [
    { value: PATHS.PROFILE, label: "Profile" },
    { value: PATHS.CONNECTIONS, label: "Connections" },
    { value: PATHS.SUBSCRIPTION, label: "Subscription" },
    { value: PATHS.SECURITY, label: "Security" }
  ];

  const action = <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2} flexGrow="1">
    <LogoutForm>
      <Button type="submit" variant="contained" color="secondary">Logout</Button>
    </LogoutForm>
  </Box>;

  const { account } = useContext(AppContext);
  const { mutate } = useSaveAccount();

  const saveAccount = (accountUpdates: Partial<Account>) => {
    const updatedAccount = mergeWith({}, account, accountUpdates, (_, srcValue, key) => {
      if (key === 'members') {
        return srcValue;
      }
    });
    mutate(updatedAccount);
  }

  return (
     <ContentBox>
      <Header
        title="Account"
        action={action}
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />
      {account && <ProfilePresenter
        account={account}
        saveAccount={saveAccount}
      />}
    </ContentBox>
  );
}
